import { render } from "./WebPage.vue?vue&type=template&id=e9f3b116"
import script from "./WebPage.vue?vue&type=script&lang=js"
export * from "./WebPage.vue?vue&type=script&lang=js"

import "./WebPage.vue?vue&type=style&index=0&id=e9f3b116&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__